// extracted by mini-css-extract-plugin
export default {"container":"Signup_container__bU81t","innerBox":"Signup_innerBox__yB9cQ","footer":"Signup_footer__8pI3r","error":"Signup_error__-oqkZ"};